<template>
  <div class="h-100">
    <div class="content-page overYscroll p-3 pb-5 h-100">
      <div class="row">
        <div class="col-8">
          <b-row>
            <b-col sm="4">
              <b-input-group>
                <date-picker
                  :placeholder="this.t.t(dictEnum.LBL_From)"
                  v-model="fromDateFilter"
                  :lang="lang"
                  type="date"
                  format="YYYY-MM-DD"
                  v-bind:editable="false"
                  v-bind:clearable="false"
                ></date-picker>
              </b-input-group>
            </b-col>
            <b-col sm="4">
              <b-input-group>
                <date-picker
                  :placeholder="this.t.t(dictEnum.LBL_From)"
                  v-model="toDateFilter"
                  :lang="lang"
                  type="date"
                  format="YYYY-MM-DD"
                  v-bind:editable="false"
                  v-bind:clearable="false"
                ></date-picker>
              </b-input-group>
            </b-col>
            <b-col sm="4">
              <button
                type="button"
                class="btn btn-transparent p-1"
                v-on:click="getLeaveApp()"
              >
                <img src="../../static/images/search.png" class="w-14" />
              </button>
            </b-col>

            <!-- <b-col sm="4">
              <b-form-group class="font-weight-normal">
                <b-form-select
                  v-model="selectUserId"
                  :options="userOptions"
                  value-field="UserID"
                  :text-field="user.Lang == 'EN' ? 'EngName' : 'ChiName'"
                  @change="getLeaveApp"
                ></b-form-select>
              </b-form-group>
            </b-col> -->
          </b-row>
        </div>
      </div>
      <div id="tableBody" class="row h-90" style="overflow-y: auto;">
        <div class="col-sm-12 pb-5">
          <div class="tab-content bg-white">
            <div
              class="
                tab-pane
                active
                prob-table
                etype-table
                leave-table
              "
            >
              <template>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th width="10%" class="text-center">
                          {{ t.t(dictEnum.LBL_DateApply) }}
                        </th>
                        <th width="10%" class="text-center">
                          {{ t.t(dictEnum.LBL_StartDay) }}
                        </th>
                        <th width="5%">
                          {{ t.t(dictEnum.LBL_TotalTime) }}
                        </th>
                        <th width="5%">
                          {{ t.t(dictEnum.LBL_LeaveType) }}
                        </th>
                        <th width="10%">
                          {{ t.t(dictEnum.LBL_ProcBy) }}
                        </th>
                        <th width="15%">
                          {{ t.t(dictEnum.LBL_Remark) }}
                        </th>
                        <th width="13%">
                          {{ t.t(dictEnum.LBL_RejReason) }}
                        </th>
                        <th width="12%">
                          {{ t.t(dictEnum.LBL_CancelReason) }}
                        </th>
                        <th width="10%">
                          {{ t.t(dictEnum.LBL_Status) }}
                        </th>
                        <th width="5%">
                          {{ t.t(dictEnum.LBL_AttachmentStatus) }}
                        </th>
                        <th width="5%">
                          <div class="float-right">
                            <font-awesome-icon
                              icon="plus"
                              v-b-modal.modal-addLeave
                              style="cursor: pointer"
                              v-if="hasRight('AlwWrite')"
                              @click="initLeaveApp"
                            />
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        id="leaveTd"
                        v-for="(item, index) in leaveAppList"
                        :key="index"
                      >
                        <td width="10%" class="text-center">
                          {{
                            item.DateApp | moment(Setting.DateTime.yyyymmddhhmm)
                          }}
                        </td>
                        <td width="10%" class="text-center">
                          {{
                            item.DateFrom
                              | moment(Setting.DateTime.yyyymmddhhmm)
                          }}
                        </td>
                        <td width="5%">
                          <div v-if="item.DaysHrs == 'hd'">
                            <span>
                              {{ item.QtyDaysHrs }}
                              {{ t.t(dictEnum.LBL_Hours) }}
                            </span>
                          </div>
                          <div v-if="item.DaysHrs == 'h'">
                            <span>
                              {{ item.QtyDaysHrs }}
                              {{ t.t(dictEnum.LBL_Hours) }}
                            </span>
                          </div>
                          <div v-if="item.DaysHrs == 'd'">
                            <span>
                              {{ item.QtyDaysHrs }}
                              {{ t.t(dictEnum.LBL_Days) }}
                            </span>
                          </div>
                        </td>
                        <td width="5%">
                          {{ LeaveTypeName(item.LeaveType) }}
                        </td>
                        <td width="10%">
                          {{ item.ProcBy }}
                        </td>
                        <td width="15%">
                          {{ item.Remark }}
                        </td>
                        <td width="13%">
                          {{ item.RejReason }}
                        </td>
                        <td width="12%">
                          {{ item.CancelReason }}
                        </td>
                        <td width="10%">
                          {{ getLeaveStatus(item) }}
                        </td>
                        <td width="5%">
                          {{ getDocStatus(item) }}
                        </td>
                        <td width="5%">
                          <b-row
                            no-gutters
                            class="text-right d-flex align-items-center"
                          >
                            <b-col cols="4">
                              <div
                                v-if="
                                  item.IsNeedUpload &&
                                    (item.Approved !=
                                      Setting.LeaveStatus.Rejected ||
                                      item.HaveAttachments)
                                "
                                href="javascript:void(0);"
                                class="pl-2"
                              >
                                <img
                                  style="cursor: pointer;"
                                  v-on:click="onClickViewAttachment(item)"
                                  v-if="item.HaveAttachments"
                                  :src="'../../static/images/eye.png'"
                                  class="w-14"
                                />
                                <img
                                  style="cursor: pointer;"
                                  v-on:click="onClickViewAttachment(item)"
                                  v-else-if="
                                    !item.HaveAttachments &&
                                      !item.IsCancelled &&
                                      (item.Approved == '' ||
                                        item.Approved == null ||
                                        item.Approved ==
                                          Setting.LeaveStatus.Approved ||
                                        item.Approved ==
                                          Setting.LeaveStatus
                                            .CancelledLeaveRejected)
                                  "
                                  :src="'../../static/images/upload1.png'"
                                  class="w-14"
                                />
                              </div>
                            </b-col>

                            <b-col cols="4">
                              <a
                                v-if="
                                  (item.Approved == null ||
                                    item.Approved == '') &&
                                    !item.IsCancelled
                                "
                                href="javascript:void(0);"
                                class="pl-2"
                                v-on:click="onEditClick(item)"
                              >
                                <img
                                  src="../../static/images/edit-pen.png"
                                  class="w-12"
                                />
                              </a>
                            </b-col>

                            <b-col cols="4">
                              <a
                                v-if="
                                  !item.IsCancelled &&
                                    (item.Approved !=
                                      Setting.LeaveStatus.Rejected &&
                                      item.Approved !=
                                        Setting.LeaveStatus.CancelLeavePending)
                                "
                                href="javascript:void(0);"
                                class="pl-2"
                                v-b-modal.modal-cancelLeave
                                v-on:click="onCancelClick(item)"
                              >
                                <img
                                  src="../../static/images/cancel.png"
                                  class="w-12"
                                />
                              </a>
                            </b-col>
                          </b-row>
                        </td>
                      </tr>
                      <tr v-if="leaveAppList.length <= 0">
                        <td colspan="8" class="text-center">
                          {{ t.t(dictEnum.MSG_RecordNotFound) }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center my-2 paggination-emp">
        <div
          class="paggination custom-paggination"
          v-if="leaveAppList && leaveAppList.length > 0"
        >
          <paginate
            :page-count="totalNoOfPages"
            :page-range="noOfPages"
            :click-handler="changePage"
            :initial-page="currentPage"
            :force-page="currentPage"
            prev-text="⯇"
            next-text="⯈"
            :containerClass="'paggination'"
          >
          </paginate>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-addLeave"
      :title="t.t(dictEnum.LBL_NewLeaveApp)"
      :ok-title="t.t(dictEnum.BTN_Submit)"
      :cancel-title="t.t(dictEnum.BTN_Cancel)"
      @ok="addLeaveApp"
      @cancel="getLeaveApp"
    >
      <div class="p-3" :key="LeaveAppRefKey">
        <!-- 员工名字 -->
        <b-row class="my-1 no-gutters">
          <b-col sm="4">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_StaffName) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <b-form-input v-model="userName" readonly></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- 假期类型 -->
        <b-row class="my-1 no-gutters">
          <b-col sm="4">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_LeaveType) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <b-form-select
                v-model="leaveApp.LeaveType"
                :disabled="isEdit"
                :options="leaveTypeList"
                value-field="LeaveType"
                :text-field="user.Lang == 'EN' ? 'EDesc' : 'CDesc'"
                @change="getStaffLeaveBal"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- 开始日 -->
        <b-row class="my-1 no-gutters">
          <b-col sm="4">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_StartDay) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <b-input-group>
                <date-picker
                  :placeholder="this.t.t(dictEnum.LBL_From)"
                  v-model="leaveApp.DateFrom"
                  :date-format-options="{
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                  }"
                  :lang="lang"
                  :disabled="
                    leaveApp.Approved != null && leaveApp.Approved != ''
                  "
                  type="date"
                  format="YYYY-MM-DD"
                  @change="getLeaveEndDate()"
                  @focus="setNotBeforeDate"
                  :not-before="limitAfterDays"
                  v-bind:editable="true"
                  v-bind:clearable="false"
                ></date-picker>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="my-1 no-gutters">
          <!-- 日数 -->
          <b-col sm="4">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_DaysOrHrs) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="2" class="pr-2">
            <b-form-group class="font-weight-normal">
              <b-form-input
                v-if="!isHalfDay"
                maxlength="1"
                size="sm"
                :disabled="this.leaveApp.LeaveType == this.BDLV.ParamVal|| (leaveApp.Approved != null && leaveApp.Approved != '')"
                @keypress="inputDigitOnly"
                v-model="leaveApp.QtyDaysHrs"
                @change="getLeaveEndDate()"
              ></b-form-input>

              <b-form-select
                v-else
                v-model="halfDayOption.model"
                :options="halfDayOption.data"
                value-field="value"
                :disabled="leaveApp.Approved != null && leaveApp.Approved != ''"
                :text-field="user.Lang == 'EN' ? 'EDesc' : 'CDesc'"
                @change="getLeaveEndDate()"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <!-- 时间 -->
          <b-col sm="5">
            <b-form-group class="font-weight-normal">
              <b-form-select
                v-model="leaveApp.DaysHrs"
                :options="dayHrsOption"
                value-field="id"
                :disabled="this.leaveApp.LeaveType == this.BDLV.ParamVal||(leaveApp.Approved != null && leaveApp.Approved != '')"
                @change="getLeaveEndDate()"
                :text-field="user.Lang == 'EN' ? 'EDesc' : 'CDesc'"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- 由几点开始 -->
        <b-row class="my-1 no-gutters" v-if="this.leaveApp.DaysHrs == 'h'">
          <b-col sm="4">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_Since) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <b-form-select
                v-model="since"
                :options="hoursOption"
                :disabled="leaveApp.Approved != null && leaveApp.Approved != ''"
                @change="getLeaveEndDate()"
                value-field="value"
                text-field="name"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- 累积 -->
        <b-row
          class="pb-3 no-gutters"
          v-if="leaveApp.LeaveType == 'AL' && showLeaveBal"
        >
          <b-col sm="4">
            <span class="bg-white input-group-text pb-0 pt-0">
              {{ t.t(dictEnum.LBL_Cumulation) }}
            </span>
          </b-col>
          <b-col sm="7">
            <div class="input-group-text pb-0 pt-0">
              {{ StaffAlBalNow.LeaveBalBF }}
            </div>
          </b-col>
        </b-row>
        <!-- 截至今天预计年假 -->
        <b-row
          class="pb-3 no-gutters"
          v-if="leaveApp.LeaveType == 'AL' && showLeaveBal"
        >
          <b-col sm="4">
            <span class="bg-white input-group-text pb-0 pt-0">
              {{ t.t(dictEnum.LBL_Leavebalasoftoday) }}
            </span>
          </b-col>
          <b-col sm="7">
            <div class="input-group-text pb-0 pt-0">
              {{ StaffAlBalNow.LeaveBal }}
            </div>
          </b-col>
        </b-row>
        <!-- 结余年假 -->
        <b-row
          class="pb-3 no-gutters"
          v-if="leaveApp.LeaveType == 'AL' || leaveApp.LeaveType == this.CLLV.ParamVal"
        >
          <b-col sm="4">
            <span class="bg-white input-group-text pb-0 pt-0">
              {{ t.t(dictEnum.LBL_Balance) }}
            </span>
          </b-col>
          <b-col sm="7">
            <div class="input-group-text pb-0 pt-0">
              {{
                showLeaveBal
                  ? StaffAlBalNow.LeaveBalCF
                  : StaffAlBalNow.LeaveBalBF
              }}
            </div>
          </b-col>
        </b-row>
        <!-- 结束日期 -->
        <b-row class="my-1 no-gutters">
          <b-col sm="4">
            <span class="bg-white input-group-text pb-0 pt-0">
              {{ t.t(dictEnum.LBL_DateEnd) }}
            </span>
          </b-col>
          <b-col sm="7">
            <div>
              <span class="input-group-text pb-0 pt-0">
                {{ leaveApp.DateTo }}
              </span>
            </div>
          </b-col>
        </b-row>

        <b-row
          v-for="(item, index) in skippedDates"
          :key="index"
          class="m-0 no-gutters"
          v-show="skippedDates && skippedDates.length > 0"
        >
          <b-col sm="4">
            <b-input-group-prepend is-text v-if="index == 0">
              <span class="bg-white text-blue-custom">
                {{ t.t(dictEnum.MENU_Holiday) }}
              </span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <span class="pb-0 bg-white input-group-text text-blue-custom">
              {{ item }}
            </span>
          </b-col>
        </b-row>
        <!-- 备注 -->
        <b-row class="my-1 no-gutters mt-3">
          <b-col sm="4">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_Remark) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <b-form-textarea
                :disabled="leaveApp.Approved != null && leaveApp.Approved != ''"
                maxlength="100"
                v-model="leaveApp.Remark"
                rows="4"
                max-rows="4"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <b-modal
      id="modal-deleteLeave"
      :title="t.t(dictEnum.LBL_Delete)"
      :ok-title="t.t(dictEnum.BTN_Submit)"
      :cancel-title="t.t(dictEnum.BTN_Cancel)"
      @ok="deleteLeaveApp"
    >
      <div
        class="
          d-flex
          flex-column
          text-center
          justify-content-center
          align-items-center
        "
      >
        <font-awesome-icon
          class="mb-5"
          :icon="['fas', 'question-circle']"
          size="9x"
          :style="{ color: 'grey' }"
        />
        {{ `${t.t(dictEnum.WARN_Delete)}` }}
      </div>
    </b-modal>

    <b-modal
      id="modal-cancelLeave"
      :title="t.t(dictEnum.BTN_Cancel)"
      :ok-title="t.t(dictEnum.BTN_Submit)"
      :cancel-title="t.t(dictEnum.BTN_Cancel)"
      @ok="cancelLeaveApp"
    >
      <div class="d-block text-center">
        <div class="form-group p-3">
          <textarea
            v-model="selectedLeaveApp.cancelReason"
            :placeholder="t.t(dictEnum.CFM_Cancel)"
            class="form-control"
            rows="9"
            cols="3"
            maxlength="200"
          ></textarea>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modal-viewAttachment"
      :hide-footer="selectedLeaveApp.IsCancelled"
      :title="t.t(dictEnum.LBL_Attachment)"
      :ok-title="t.t(dictEnum.BTN_Submit)"
      :cancel-title="t.t(dictEnum.BTN_Cancel)"
      @ok="editLeaveAppDoc"
    >
      <div class="p-2">
        <b-row
          class="my-1 no-gutters mt-3"
          v-if="
            !selectedLeaveApp.IsCancelled &&
              (selectedLeaveApp.Approved != Setting.LeaveStatus.Rejected &&
                selectedLeaveApp.Approved !=
                  Setting.LeaveStatus.CancelLeavePending)
          "
        >
          <b-col sm="4">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_Attachment) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <b-form-file
                multiple
                @change="
                  onFileChange($event, $event.target.name, $event.target.files)
                "
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
              ></b-form-file>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row
          no-gutters
          v-if="
            selectedLeaveApp.AttachmentList &&
              selectedLeaveApp.AttachmentList.length > 0
          "
        >
          <b-col
            v-for="(item, index) in selectedLeaveApp.AttachmentList"
            :key="index"
            cols="6"
          >
            <div>
              <a
                v-if="
                  selectedLeaveApp.Approved == null ||
                    selectedLeaveApp.Approved == '' ||
                    item.DocID == ''
                "
                href="javascript:void(0);"
                v-on:click="deleteLeaveAttachment(index)"
              >
                <img src="../../static/images/cancel.png" class="w-8" />
              </a>
            </div>
            <div
              v-viewer
              v-if="
                item.DocMime.indexOf('image/') > -1 &&
                  item.DocURL != null &&
                  item.DocURL != ''
              "
            >
              <img :src="item.DocURL" class="w-50" />
            </div>
            <a
              v-if="
                item.DocMime.indexOf('image/') == -1 &&
                  item.DocURL != null &&
                  item.DocURL != ''
              "
              download
              :href="item.DocURL"
            >
              <img src="../../static/images/document.png" class="w-20" />
            </a>
          </b-col>
        </b-row>
        <!-- <div class="row xs-gutters">
          <div
            v-for="(item, index) in selectedLeaveApp.AttachmentList"
            :key="index"
          >
            <span v-if="!item.IsDeleted" class="d-none">
              {{ (item.DocID = index + 1) }}
            </span>
            <div
              class="col-6"
              v-if="item.DocURL != null && item.DocURL != '' && !item.IsDeleted"
            >
              <div
                v-viewer
                v-if="
                  item.DocMime.indexOf('image/') > -1 &&
                    item.DocURL != null &&
                    item.DocURL != ''
                "
              >
                <img :src="item.DocURL" class="w-50" />
              </div>
              <a
                v-if="
                  item.DocMime.indexOf('image/') == -1 &&
                    item.DocURL != null &&
                    item.DocURL != ''
                "
                download
                :href="item.DocURL"
              >
                <img src="../../static/images/document.png" class="w-20"
              /></a>
            </div>
          </div>
        </div> -->
      </div>
    </b-modal>

    <!-- Delete Attachment Modal Start -->
    <b-modal
      id="deleteAttachmentModal"
      :title="t.t(dictEnum.LBL_Delete)"
      :ok-title="t.t(dictEnum.BTN_Ok)"
      :cancel-title="t.t(dictEnum.BTN_Cancel)"
      @ok="OnAttachmentDeleteClick"
    >
      <div class="p-2">
        <div class="row xs-gutters">
          <div class="p-3">
            <div class="confirm-msg">
              {{ t.t(dictEnum.WARN_DeleteAttachment) }} ?
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- Delete Attachment Modal End -->

    <b-modal
      id="modal-deleteAttachmentApprov"
      :title="t.t(dictEnum.LBL_Attachment)"
      :ok-title="t.t(dictEnum.BTN_Confirm)"
      :cancel-title="t.t(dictEnum.BTN_Cancel)"
      @ok="OnAttachmentDeleteClick"
    >
      <div class="p-2">
        <div class="d-block text-center">
          <div class="form-group">
            <input
              v-model="Username"
              :placeholder="t.t(dictEnum.LBL_Username)"
              class="form-control"
            />
          </div>
          <div class="form-group">
            <input
              v-model="Password"
              type="password"
              :placeholder="t.t(dictEnum.LBL_Password)"
              class="form-control"
            />
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import MenuRightSerivce from "@/service/MenuRightService";
import LeaveTypeService from "@/service/LeaveTypeService";
import UserService from "@/service/UserService";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import SweetAlertService from "@/service/SweetAlertService";
import StaffService from "@/service/StaffService";
import StoreGetter from "@/constants/StoreGetter";
import { LeaveApp } from "@/model/LeaveApp";
import { LeaveEndDate } from "@/model/LeaveEndDate";
import { datePickerLang } from "@/constants/globalConstants";
import DatePicker from "vue2-datepicker";
import InputHelper from "@/common/helper/InputHelper";
import { Attachment } from "@/model/Attachment";
import Paginate from "vuejs-paginate";
import DataSyncService from "@/service/DataSyncService";
import TreeNodeHelper from "@/common/helper/TreeNodeHelper";
import ArrayHelper from "@/common/helper/ArrayHelper";
import Setting from "@/constants/Settings";
import ReportService from "@/service/ReportService";
export default {
  data() {
    return {
      SysParamData: {},
      BDLV:"",
      CLLV:"",
      UserDOB:'',
      UserDOBDays:90,
      UserCLDays:60,
      menuRights: { allRights: {}, rightsForThisMenu: {} },
      menuId: Setting.MenuID.LeaveApplication,
      amOrPm: "am",
      halfDayOption: {
        data: [
          { EDesc: "AM", CDesc: "上午", value: "AM" },
          { EDesc: "PM", CDesc: "下午", value: "PM" }
        ],
        model: "AM"
      },
      dayHrsOption: [
        { EDesc: "Days", CDesc: "日", value: "Days", id: "d" },
        { EDesc: "Hours", CDesc: "小時", value: "Hours", id: "h" },
        { EDesc: "Half Day", CDesc: "半日", value: "HalfDay", id: "hd" }
      ],
      since: "",
      Setting: Setting,
      hoursOption: [],
      today: moment(new Date())
        .startOf("day")
        .toDate(),
        limitAfterDays:'',
      leaveTypeList: [],
      selectedLeaveApp: {},
      leaveAppList: [],
      userList: [],
      dict: {},
      dictEnum: dictEnum,
      fromDateFilter: moment(new Date())
        .subtract(3, "months")
        .format(Setting.DateTime.yyyymmdd),
      toDateFilter: moment(new Date())
        .add(3, "months")
        .format(Setting.DateTime.yyyymmdd),
      columns: [
        "DateAdd",
        "DateFrom",
        "DaysHrs",
        "LeaveType",
        "ProcBy",
        "Remark",
        "RejReason",
        "Approved",
        "CancelReason",
        "Action"
      ],
      options: {},
      leaveEndDate: new LeaveEndDate(),
      leaveApp: new LeaveApp(),
      lang: datePickerLang,
      attachment: new Attachment(),
      take: 15,
      skip: 0,
      totalNoOfPages: 0,
      noOfPages: 5,
      currentSelectedPage: 0,
      currentPage: 1,
      totalRecords: 0,
      LeaveAppRefKey: 0,
      isEdit: false,
      selectUserId: "",
      Username: "",
      Password: "",
      daysAdv:1,
      StaffAlBalNow: {}
    };
  },
  components: {
    DatePicker,
    Paginate
  },
  computed: {
    t() {
      return t;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    },
    userName() {
      return this.$store.getters[StoreGetter.user].Lang == "EN"
        ? this.$store.getters[StoreGetter.user].EngName +
            " " +
            this.$store.getters[StoreGetter.user].EngLastName
        : this.$store.getters[StoreGetter.user].ChiLastName +
            this.$store.getters[StoreGetter.user].ChiName;
    },
    skippedDates() {
      let skippedDates = [];
      if (this.leaveApp.DaysHrs == "Days") {
        let endDates = JSON.parse(JSON.stringify(this.leaveEndDate));
        if (endDates.skippedSat == undefined) {
          endDates.skippedSat = [];
        }
        if (endDates.skippedSun == undefined) {
          endDates.skippedSun = [];
        }
        if (endDates.skippedHoliday == undefined) {
          endDates.skippedHoliday = [];
        }
        endDates.skippedSat = endDates.skippedSat.map(x => `${x} (Sat)`);
        endDates.skippedSun = endDates.skippedSun.map(x => `${x} (Sun)`);
        endDates.skippedHoliday = endDates.skippedHoliday.map(
          x => `${x} (${this.t.t("MENU_Holiday")})`
        );
        skippedDates = endDates.skippedSat
          .concat(endDates.skippedSun)
          .concat(endDates.skippedHoliday);
      }
      return skippedDates;
    },
    isHalfDay() {
      return this.leaveApp.DaysHrs === "hd";
    },

    userOptions() {
      const userId = this.$store.getters[StoreGetter.user].UserID;
      const tree = TreeNodeHelper.flattenToTree(
        this.$data.userList,
        "UserID",
        "children",
        "SupervisorID"
      );
      // const tree = this.$data.userList.filter(
      //   x => x.SupervisorID == userId || x.UserID == userId
      // );
      return tree;
    },
    showLeaveBal() {
      const find = this.$store.state.SysParamsStore.sysParams.find(
        x => x.ParamCode == Setting.SysParams.ShowLvBalance
      );
      if (find) {
        return find.ParamVal.toLowerCase() == "true";
      }
    }
  },
  methods: {
    async getSysParams() {
      const obj = {};
      const response = await DataSyncService.getSysParams(obj);
      if (response.data.IsSuccess) {
        this.SysParamData = response.data.Data;
        this.BDLV=response.data.Data.find(item => item.ParamCode === 'BDLV');
        this.CLLV=response.data.Data.find(item => item.ParamCode === 'CLLV');
      }
    },
    setNotBeforeDate(){
      if(this.daysAdv>0){
        this.limitAfterDays = moment()
        .add(this.daysAdv, "d")
        .format("YYYY-MM-DD");
      }else{
        this.limitAfterDays = "1900-01-01";
      }
    },
    async init() {
      const tableBody = await document.getElementById("tableBody");
      const bodyHeight = tableBody.offsetHeight;
      var tableHeaderHeight = await $(".leave-table table thead").height();
      var tHeadHeight =
        tableHeaderHeight != undefined && tableHeaderHeight != 0
          ? tableHeaderHeight
          : 38;

      var tableHeight = bodyHeight - tHeadHeight * 2;
      this.take = Number((tableHeight / 40).toFixed(0));
      this.getLeaveApp();
    },
    hasRight(key, menuId) {
      if (
        Object.keys(this.menuRights.allRights) &&
        Object.keys(this.menuRights.allRights).length === 0
      ) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },
    LeaveTypeName(item) {
      const find = this.leaveTypeList.find(x => x.LeaveType == item);
      if (find) {
        return this.$store.getters[StoreGetter.user].Lang == "EN"
          ? find.EDesc
          : find.CDesc;
      } else {
        return "";
      }
    },
    needUploadFile(item) {
      const find = this.leaveTypeList.find(x => x.LeaveType == item);
      if (find) {
        return find.IsNeedUpload;
      } else {
        return false;
      }
    },
    inputDigitOnly(evt) {
      InputHelper.inputDigitOnly(evt);
    },
    onClickDelete(row) {
      this.selectedLeaveApp = row;
    },
    onCancelClick(row) {
      this.selectedLeaveApp = row;
    },
    async onEditClick(row) {
      this.leaveApp = JSON.parse(JSON.stringify(row));
      this.leaveApp.AttachmentList = [];
      const obj = {
        txNum: this.leaveApp.TxNum,
        userId: this.$store.getters[StoreGetter.user].UserID
      };
      const response = await UserService.getLeaveAttachments(obj);
      if (response.data.IsSuccess) {
        this.leaveApp.AttachmentList = await response.data.Data;
        this.isEdit = await true;
        this.getStaffLeaveBal(this.leaveApp.LeaveType);
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
      await this.$bvModal.show("modal-addLeave");
      // $("#modal-addLeave").modal("show");
    },
    async onClickViewAttachment(row) {
      this.selectedLeaveApp = row;
      const obj = {
        txNum: this.selectedLeaveApp.TxNum
      };
      const response = await UserService.getLeaveAttachments(obj);
      if (!response.data.IsSuccess) {
        SweetAlertService.warning("Warn", response.data.Message);
      } else {
        this.selectedLeaveApp.AttachmentList = response.data.Data;
      }
      this.$bvModal.show("modal-viewAttachment");
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },
    formateDatelist(value) {
      return moment(String(value)).format(Setting.DateTime.yyyymmdd);
    },
    async getLeaveEndDate() {
      const sysParams = this.$store.getters[StoreGetter.sysParams];
      const dayStart = sysParams.find(
        x => x.ParamCode === Setting.SysParams.DayStart
      );
      const dayEnd = sysParams.find(
        x => x.ParamCode === Setting.SysParams.DayEnd
      );
      const qtyOfAmLeave = sysParams.find(
        x => x.ParamCode === Setting.SysParams.QtyOfAmLeave
      );
      const qtyOfPmLeave = sysParams.find(
        x => x.ParamCode === Setting.SysParams.QtyOfPmLeave
      );

      switch (this.leaveApp.DaysHrs) {
        case "d":
          const obj = {
            fromDate: moment(this.leaveApp.DateFrom).format(
              Setting.DateTime.yyyymmdd
            ),
            numberOfDays: this.leaveApp.QtyDaysHrs
          };
          const response = await UserService.getLeaveEndDate(obj);
          if (response.data.IsSuccess) {
            this.leaveEndDate = response.data.Data;
            this.leaveApp.DateFrom = `${moment(this.leaveApp.DateFrom).format(
              Setting.DateTime.yyyymmdd
            )} ${dayStart.ParamVal}`;
            this.leaveApp.DateTo = response.data.Data.endDate;
          }
          break;
        case "hd":
          if (this.halfDayOption.model === "AM") {
            this.leaveApp.DateFrom = `${moment(this.leaveApp.DateFrom).format(
              Setting.DateTime.yyyymmdd
            )} ${dayStart.ParamVal}`;
            this.leaveApp.DateTo = moment(this.leaveApp.DateFrom)
              .add(qtyOfAmLeave.ParamVal, "hours")
              .format(Setting.DateTime.yyyymmddhhmm);
            this.leaveApp.QtyDaysHrs = qtyOfAmLeave.ParamVal;
          } else {
            this.leaveApp.DateTo = `${moment(this.leaveApp.DateFrom).format(
              Setting.DateTime.yyyymmdd
            )} ${dayEnd.ParamVal}`;
            this.leaveApp.DateFrom = moment(this.leaveApp.DateTo)
              .subtract(qtyOfPmLeave.ParamVal, "hours")
              .format(Setting.DateTime.yyyymmddhhmm);
            this.leaveApp.QtyDaysHrs = qtyOfPmLeave.ParamVal;
          }
          break;
        case "h":
          this.leaveApp.DateFrom = `${moment(this.leaveApp.DateFrom).format(
            Setting.DateTime.yyyymmdd
          )} ${this.since}`;
          this.leaveApp.DateTo = moment(this.leaveApp.DateFrom)
            .add(this.leaveApp.QtyDaysHrs, "hours")
            .format(Setting.DateTime.yyyymmddhhmm);
          break;
      }
      this.LeaveAppRefKey++;
    },
    initLeaveApp() {
      this.leaveApp = new LeaveApp();
      this.leaveEndDate = new LeaveEndDate();
      this.isEdit = false;
      this.getStaffLeaveBal();
    },
    initHourOptions() {
      const sysParams = this.$store.getters[StoreGetter.sysParams];
      let rosterBase = sysParams.find(
        x => x.ParamCode === Setting.SysParams.RosterBase
      );
      let dayStart = sysParams.find(
        x => x.ParamCode === Setting.SysParams.DayStart
      );
      let dayEnd = sysParams.find(
        x => x.ParamCode === Setting.SysParams.DayEnd
      );

      this.hoursOption.push(dayStart.ParamVal);

      const opt = JSON.parse(JSON.stringify(this.hoursOption));

      this.since = dayStart.ParamVal;
      let start = dayStart.ParamVal;

      while (start < dayEnd.ParamVal) {
        start = moment(start, "HH:mm")
          .add(30, "minutes")
          .format("HH:mm");
        opt.push(start);
      }
      this.hoursOption.push(dayEnd.ParamVal);
      this.hoursOption = opt;
    },

    async editLeaveAppDoc() {
      const obj = {
        leave: this.selectedLeaveApp
      };
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: `${t.t(dictEnum.WARN_ConfirmUpload)}`,
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        const response = await UserService.uploadAttachments(obj);
        if (response.data.IsSuccess) {
          SweetAlertService.success("Success", response.data.Message);
          this.selectedLeaveApp = new LeaveApp();
          this.getLeaveApp();
        } else {
          SweetAlertService.warning("Warn", response.data.Message);
        }
      }
    },

    async addLeaveApp() {
     //假期结余不足不允许申请
      if(this.leaveApp.LeaveType == 'AL' || this.leaveApp.LeaveType == this.CLLV.ParamVal){
        console.log(this.StaffAlBalNow.LeaveBalCF);
        if(this.StaffAlBalNow.LeaveBalCF!=null){
          // let CFDays=this.StaffAlBalNow.LeaveBalCF.replace(/[^-?\d.]/g, '');
          let HoursCF=this.StaffAlBalNow.LeaveBalHoursCF;
          let DaysCF=this.StaffAlBalNow.LeaveBalDaysCF;
          if(HoursCF<0&&DaysCF>0){
            DaysCF=-1*DaysCF;
          }
           if(HoursCF>0&&DaysCF<0){
            HoursCF=-1*HoursCF;
          }
          let CFDays=(DaysCF*8)+HoursCF;
          let QtyCFDays=0;
          console.log(this.leaveApp);
          if(this.leaveApp.DaysHrs === 'd'){
            //申请单位为日
            QtyCFDays=this.leaveApp.QtyDaysHrs*8;
          }else{
              //申请单位为小时
            QtyCFDays=this.leaveApp.QtyDaysHrs;
          }
           console.log(CFDays,QtyCFDays,'假期余额小时数及用户申请小时数');
        if(CFDays<=0 || CFDays<QtyCFDays){
          if(this.user.Lang == 'EN'){
            SweetAlertService.warning("Warn",(this.leaveApp.LeaveType == 'AL'?'Annual Leave':'Compensation Leave') + this.t.t(dictEnum.WARN_InsufficientBalance));
          }else{
            SweetAlertService.warning("Warn",(this.leaveApp.LeaveType == 'AL'?'年假':'補假') + this.t.t(dictEnum.WARN_InsufficientBalance));
          }
        return;
        }
        }else{
          if(this.user.Lang == 'EN'){
            SweetAlertService.warning("Warn",(this.leaveApp.LeaveType == 'AL'?'Annual Leave':'Compensation Leave') + this.t.t(dictEnum.WARN_InsufficientBalance));
          }else{
            SweetAlertService.warning("Warn",(this.leaveApp.LeaveType == 'AL'?'年假':'補假') + this.t.t(dictEnum.WARN_InsufficientBalance));
          }
          return;
        }
      }
      // 生日假超过范围不允许申请或已申请过不允许申请
      if(this.leaveApp.LeaveType == this.BDLV.ParamVal){
        //申请开始日转格式(以防格式未转换，导致无法截取)
        this.leaveApp.DateFrom=moment(this.leaveApp.DateFrom).format(Setting.DateTime.yyyymmdd);
        //申请生日假开始日期(截取月日)
        let UserFrom=(this.leaveApp.DateFrom).split('-').slice(1).join('-');
        const currentYear = new Date().getFullYear();
        //申请日期和生日日期比较
        const d1 = new Date(`${currentYear}-${UserFrom}`);//申请日
        const d2 = new Date(`${currentYear}-${this.UserDOB}`);//生日日
        const diffTime = Math.abs(d2 - d1);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));//差值
        let result= diffDays <= this.UserDOBDays && d1>=d2;//是否在规定的生日范围内
        if (!result) {
          //生日假超出申请范围，只能申请您生日前后n天范围内的日期
          SweetAlertService.warning("Warn",this.t.t(dictEnum.WARN_LeaveScopeLimits));
          return;
      }
      //查询当年是否已申请过生日假
      const startOfYear = moment().startOf('year').format('YYYY-MM-DD'); // 本年的第一天
      const endOfYear = moment().endOf('year').format('YYYY-MM-DD');     // 本年的最后一天
       const obj2 = {
        userId: this.$store.getters[StoreGetter.user].UserID,
        startDate: moment(startOfYear).format(Setting.DateTime.yyyymmdd),
        endDate: moment(endOfYear).format(Setting.DateTime.yyyymmdd),
        sortField: "DateAdd",
        sortOrder: 0,
        take: 100,
        skip: this.skip
      };
      const response = await UserService.getUserLeaves(obj2);
      if (response.data.IsSuccess) {
        //若无有申请记录则return,不允许申请
        if(response.data.Data.Item1.length>0){
          let LeaveList=response.data.Data.Item1.some(item => item.LeaveType ==this.leaveApp.LeaveType && !item.IsCancelled);
          if(LeaveList){
           SweetAlertService.warning("Warn",this.t.t(dictEnum.WARN_BLApplyAgain));
          return;
          }
        }
      }
      }
      //补假超过范围不允许申请
      if(this.leaveApp.LeaveType == this.CLLV.ParamVal){
        //获取从开始日期起可申请休假范围的初始日期
        let originalDate =moment(this.leaveApp.DateFrom);
        const newDate = originalDate.subtract(this.UserCLDays, 'days').format(Setting.DateTime.yyyymmddhhmm);
        //定义参数
        let obj2 = {
        userId: this.$store.getters[StoreGetter.user].UserID,
        leaveType: this.leaveApp.LeaveType,
        dept:"",
        dateTo:moment(this.leaveApp.DateFrom).format(Setting.DateTime.yyyymmddhhmm),
        dateFrom: newDate,
        inclSubordinate:0,
        compCode:""
      };
      const res= await ReportService.getLeaveBalance(obj2);
      if (res.data.IsSuccess) {
        if(res.data.Data.length>0 && res.data.Data[0].staffLeaveRecords){
          const allAdditionsEmpty = res.data.Data[0].staffLeaveRecords.every(item => item.Addition === '');
          console.log(this.UserCLDays,'申请期限');
          if(allAdditionsEmpty){
          //補假超出申請範圍，您只能在加班後n天內申請。
         SweetAlertService.warning("Warn",this.t.t(dictEnum.WARN_LeaveScopeLimits));
         return;
       }
        }else{
           //補假超出申請範圍，您只能在加班後n天內申請。
          SweetAlertService.warning("Warn",this.t.t(dictEnum.WARN_LeaveScopeLimits));
          return;
        }
      }

      }
      
      if (!this.leaveApp.DateFrom) {
        SweetAlertService.warning(
          "Warn",
          this.t.t(dictEnum.LBL_StartDay) + this.t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }

      if (this.leaveApp.DaysHrs == "h") {
        if (!this.leaveApp.QtyDaysHrs) {
          SweetAlertService.warning(
            "Warn",
            this.t.t(dictEnum.WARN_HoursOutOfBound)
          );
          return;
        }
        if (this.leaveApp.QtyDaysHrs > 8) {
          SweetAlertService.warning(
            "Warn",
            this.t.t(dictEnum.WARN_HoursOutOfBound)
          );
          return;
        }
      } else if (this.leaveApp.DaysHrs == "d") {
        if (!this.leaveApp.QtyDaysHrs) {
          SweetAlertService.warning(
            "Warn",
            this.t.t(dictEnum.WARN_DaysOutOfBound)
          );
          return;
        }
      }

      const obj = {
        UserID: this.$store.getters[StoreGetter.user].UserID,
        DateFrom: moment(this.leaveApp.DateFrom).format(
          Setting.DateTime.yyyymmddhhmmss
        ),
        DaysHrs: this.leaveApp.DaysHrs,
        QtyDaysHrs: this.leaveApp.QtyDaysHrs,
        LeaveType: this.leaveApp.LeaveType,
        Remark: this.leaveApp.Remark,
        TxNum: this.leaveApp.TxNum,
        DateAdd: moment(this.leaveApp.DateAdd).format(
          Setting.DateTime.yyyymmddhhmmss
        ),
        DateProc: moment(this.leaveApp.DateProc).format(
          Setting.DateTime.yyyymmddhhmmss
        ),
        AttachmentList: this.leaveApp.AttachmentList
      };
      let response;
      if (this.leaveApp.TxNum == "") {
        response = await UserService.addLeave(obj);
      } else {
        response = await UserService.editLeave(obj);
      }

      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        this.leaveApp = new LeaveApp();
        this.getLeaveApp();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getLeaveType() {
      const response = await LeaveTypeService.getLeaveTypes();
      if (!response.data.IsSuccess) {
        SweetAlertService.warning("Warn", response.data.Message);
      } else {
        this.leaveTypeList = response.data.Data;
        const leaveBL = response.data.Data.find(item => item.LeaveType === this.BDLV.ParamVal);
        setTimeout(() => {
          this.UserDOBDays= leaveBL ? leaveBL.Days : 90;
        console.log(leaveBL.Days,'生日假假限定的天数');
        const leaveCL = response.data.Data.find(item => item.LeaveType === this.CLLV.ParamVal);
        this.UserCLDays= leaveCL ? leaveCL.Days : 60;
         console.log(leaveCL.Days,'补假限定的天数');
        }, 2000);
      
      }
    },
    async getStaffLeaveBal() {
    if(this.leaveApp.LeaveType == this.BDLV.ParamVal){
      this.leaveApp.QtyDaysHrs=1;
      this.leaveApp.DaysHrs ='d';
    }
      this.leaveTypeList.forEach(item => {
        if(item.LeaveType==this.leaveApp.LeaveType){
          this.daysAdv=item.DaysAdv;
        }
      });
      if(!this.isEdit){
        this.setNotBeforeDate();
        if(this.daysAdv>0){
          this.leaveApp.DateFrom=this.limitAfterDays;
        }else{
          this.leaveApp.DateFrom= moment().format("YYYY-MM-DD"); // 设置为今日日期
        }
          
        }
      const obj = {
        staffID: this.user.UserID,
        leaveType: this.leaveApp.LeaveType
      };
      const response = await StaffService.getStaffLeaveBal(obj);
      if (!response.data.IsSuccess) {
        SweetAlertService.warning("Warn", response.data.Message);
      } else {
        this.StaffAlBalNow = response.data.Data;
      }
    },
    async getLeaveApp() {
      const obj = {
        userId: this.$store.getters[StoreGetter.user].UserID,
        startDate: moment(this.fromDateFilter).format(
          Setting.DateTime.yyyymmdd
        ),
        endDate: moment(this.toDateFilter).format(Setting.DateTime.yyyymmdd),
        sortField: "DateAdd",
        sortOrder: 0,
        take: this.take,
        skip: this.skip
      };
      const response = await UserService.getUserLeaves(obj);
      if (!response.data.IsSuccess) {
        SweetAlertService.warning("Warn", response.data.Message);
      } else {
        this.leaveAppList = response.data.Data.Item1;
        this.totalRecords = response.data.Data.Item2;
        this.totalPages();
        this.getStaffLeaveBal();
        if (
          response.data.Data.Item1.length == 0 &&
          response.data.Data.Item2 > 0 &&
          this.currentPage > 1
        ) {
          this.changePage(this.currentPage - 1);
        }
      }
    },
    isNotAfterToday(date) {
      const today = moment(new Date())
        .startOf("day")
        .format(Setting.DateTime.yyyymmdd);
      const dateFrom = moment(date).format(Setting.DateTime.yyyymmdd);
      return moment(today).isSameOrBefore(dateFrom, "day");
    },
    async deleteLeaveApp() {
      var obj = {
        txNum: this.selectedLeaveApp.TxNum,
        userId: this.$store.getters[StoreGetter.user].UserID
      };

      const response = await UserService.deleteLeaveApp(obj);
      if (!response.data.IsSuccess) {
        SweetAlertService.warning("Warn", response.data.Message);
      } else {
        SweetAlertService.success("Success", response.data.Message);
        this.getLeaveApp();
      }
    },
    async cancelLeaveApp() {
      if (!this.selectedLeaveApp.cancelReason) {
        SweetAlertService.warning("Warn", this.t.t(dictEnum.CFM_Cancel));
        this.selectedLeaveApp.cancelReason = "";
        return;
      }
      var obj = {
        txNum: this.selectedLeaveApp.TxNum,
        cancelReason: this.selectedLeaveApp.cancelReason
      };

      const response = await UserService.cancelLeaveApp(obj);
      if (!response.data.IsSuccess) {
        SweetAlertService.warning("Warn", response.data.Message);
      } else {
        SweetAlertService.success("Success", response.data.Message);
        this.getLeaveApp();
      }
    },
    getLeaveStatus(app) {
      if (app.Approved == null || app.Approved == "")
        return t.t(dictEnum.LBL_Pending);
      if (app.Approved == Setting.LeaveStatus.Approved && !app.IsCancelled)
        return t.t(dictEnum.LBL_Approved);
      if (app.Approved == Setting.LeaveStatus.Rejected)
        return t.t(dictEnum.LBL_Rejected);
      if (app.Approved == Setting.LeaveStatus.Approved && app.IsCancelled)
        return t.t(dictEnum.LBL_Cancelled);
      if (app.Approved == Setting.LeaveStatus.CancelLeavePending)
        return t.t(dictEnum.LBL_CancelledLeavePending);
      if (app.Approved == Setting.LeaveStatus.CancelledLeaveApproved)
        return t.t(dictEnum.LBL_CancelledLeaveApproved);
      if (app.Approved == Setting.LeaveStatus.CancelledLeaveRejected)
        return t.t(dictEnum.LBL_CancelledLeaveReject);
      else return app.Approved;
    },

    getDocStatus(item) {
      if (item.IsNeedUpload) {
        if (item.DocStatus == null || item.DocStatus == "") {
          if (item.HaveAttachments) {
            return t.t(dictEnum.LBL_Pending);
          } else {
            return t.t(dictEnum.LBL_IsNeedUpload);
          }
        }
        if (item.DocStatus == Setting.LeaveStatus.Approved)
          return t.t(dictEnum.LBL_Approved);
        if (item.DocStatus == Setting.LeaveStatus.Rejected)
          return t.t(dictEnum.LBL_Rejected);
      } else {
        return "";
        // return t.t(dictEnum.LBL_NotNeedSubmit);
      }
    },

    OnAttachmentOpen: function() {
      var self = this;
      $("#attachmentFile").click();
    },
    onFileChange(e, fieldName, fileList) {
      var self = this;
      if (!fileList.length) return;
      var counter = -1,
        file;
      while ((file = e.target.files[++counter])) {
        const reader = new FileReader();
        reader.onload = (function(file) {
          return function(e1) {
            var path = reader.result ? reader.result.toString() : "";
            self.attachment = new Attachment();
            self.attachment.DocURL = path;
            self.attachment.DocFile =
              path.indexOf(",") != -1 ? path.split(",").pop() : "";
            self.attachment.Doc = self.attachment.DocFile;
            self.attachment.DocMime = file.type;
            self.attachment.IsImageFile =
              path.indexOf("image") != -1 ? true : false;
            if (self.selectedLeaveApp.AttachmentList == undefined) {
              self.selectedLeaveApp.AttachmentList = [];
            }
            self.selectedLeaveApp.AttachmentList.push(self.attachment);
          };
        })(file);
        if (file) {
          reader.readAsDataURL(file);
        }
      }
    },
    deleteAttachmentPopup: function(data) {
      if (
        !this.selectedLeaveApp.IsCancelled &&
        this.selectedLeaveApp.Approved == "A"
      ) {
        this.$bvModal.show("modal-deleteAttachmentApprov");
      } else {
        this.$bvModal.show("deleteAttachmentModal");
      }
      this.selectedAttachment = new Attachment();
      this.selectedAttachment = data;
    },
    async OnAttachmentDeleteClick() {
      var obj = {
        txNum: this.selectedLeaveApp.TxNum,
        docId: this.selectedAttachment.DocID
      };
      const response = await UserService.deleteLeaveAppAttachments(obj);
      if (!response.data.IsSuccess) {
        SweetAlertService.warning("Warn", response.data.Message);
      } else {
        SweetAlertService.success("Success", response.data.Message);
        this.getLeaveApp();
        this.closeAttachmentPopup();
      }
    },
    closeAttachmentPopup: function() {
      this.selectedAttachment = new Attachment();
      this.$bvModal.hide("deleteAttachmentModal");
      this.$bvModal.hide("modal-viewAttachment");
    },
    downloadFile: function(doc) {
      var image = new Image();
      image.src = doc.DocURL;
      var w = window.open(doc.DocURL);
      w.document.write(doc.outerHTML);
    },
    //Pagination Method start
    changePage(pagenumber) {
      this.currentPage = pagenumber;
      this.currentSelectedPage = pagenumber - 1;
      this.setPage();
    },
    setPage() {
      this.skip = this.take * (this.currentPage - 1) - 1;
      if (this.skip != 0) {
        this.skip++;
      }
      this.getLeaveApp();
    },
    async deleteLeaveAttachment(index) {
      const data = this.selectedLeaveApp.AttachmentList[index];
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: `${t.t(dictEnum.LBL_Delete)}?`,
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        this.selectedLeaveApp.AttachmentList.splice(index, 1);
      }
    },
    totalPages() {
      var numbers = this.totalRecords / this.take;
      var pages = 0;
      if (Number.isInteger(numbers)) {
        pages = numbers;
      } else {
        pages = Math.floor(numbers) + 1;
      }
      this.totalNoOfPages = pages;
    },

    async getUserList() {
      const obj = {
        searchText: "",
        sortField: "",
        isInResigneUser: false
      };
      const response = await UserService.getUsers(obj);
      if (response.data.IsSuccess) {
        this.userList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getUserDetail() {
      const obj = {
        staffId:this.$store.getters[StoreGetter.user].UserID
      };
      const response = await StaffService.getStaffDetail(obj);
      if (response.data.IsSuccess) {
       this.UserDOB=(response.data.Data.DOB).split('-').slice(1).join('-');;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
  },
  mounted() {
    this.getSysParams();
    this.assignRights();
    this.init();
    this.getLeaveType();
    this.getUserList();
    this.getUserDetail();
    this.initHourOptions();
    this.options = {
      filterable: false,
      perPageValues: [],
      sortable: [],
      skin: "table table-hover v-midle",
      headings: {
        DateAdd: this.t.t(dictEnum.LBL_DateAdded),
        DateFrom: this.t.t(dictEnum.LBL_StartDay),
        DaysHrs: this.t.t(dictEnum.LBL_TotalTime),
        LeaveType: this.t.t(dictEnum.MENU_LeaveType),
        ProcBy: this.t.t(dictEnum.LBL_ProcBy),
        Remark: this.t.t(dictEnum.LBL_Remark),
        RejReason: this.t.t(dictEnum.LBL_RejReason),
        Approved: this.t.t(dictEnum.LBL_Status),
        CancelReason: this.t.t(dictEnum.LBL_CancelReason),
        Delete: this.t.t(dictEnum.LBL_Delete)
      },
      texts: {
        noResults: this.t.t(dictEnum.LBL_NoData),
        count: ``
      }
    };
  }
};
</script>
<style scoped>
.table_space th {
  width: 20%;
}

.overYscroll {
  overflow-y: scroll;
}

.mx-calendar-icon {
  width: 100%;
  height: auto !important;
  color: #555;
  stroke-width: 8px;
  stroke: currentColor;
  fill: currentColor;
}
.input-group-text {
  background: white;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/S030000-LeaveApplication.vue